import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CustomerDetails from "../Diagnosis/CustomerDetails";

import { Box } from "@mui/material";
import configServ from "../../../services/config";
import { useDispatch, useSelector } from "react-redux";
import { triggerLoader } from "../../../redux/reducers/LoaderTrigger";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import PrescriptionEntry from "../Customers/PrescriptionEntry";
import CrosscheckPage from "../Customers/CrosscheckPage";
import PainAreaForm from "../Customers/PainAreaForm";
import CardHeadMenu from "../CardHeadMenu/CardHeadMenu";
import { motion } from "framer-motion";
import DiagnosisTable from "./DiagnosisTable";

export default function CreateDiagnosis({ customer }) {
  const prescriptionRef = useRef(); // ref for child
  const [isCreate, setIsCreate] = useState(false);
  const CrosscheckPageRef = useRef();
  const [isEdit, setIsEdit] = useState(false);

  const [diagnoses, setDiagnoses] = useState([]);
  const handlePopup = () => {
    try {
      if (isCreate === true) {
      }
      setIsCreate(!isCreate);
      handleResetAll()
    } catch (error) {
      console.log(error);
    }
  };

  const [formData, setFormData] = useState({
    item_name: "",
    group_name: "",
    categoryname: "",
    brand_name: "",
  });
  const [diagnosisData, setDiagnosisData] = useState([]);
  const [diagnsisId, setdiagnosisId] = useState(null);


  const [selectedUserId, setSelectedUserId] = useState(null);
  const dispatch = useDispatch();
  const [enquiry, setEnquiry] = useState([]);
  const [item_id, setItem_id] = useState(null);
  const [muscle_code, setMuscleCode] = useState(null);
  const {
    company_id,
    user_id,
    companyName,
    companyAddress,
    companyState,
    companyCountry,
  } = useSelector((state) => state.GlobalVariables);

  const [questionnaireResponse, setQuestionnaireResponse] = useState([]);
  const [prescriptionData, setPrescriptionData] = useState(null);


  const [loading, setLoading] = useState(false);
  const handleResponses = (payload) => {
    setQuestionnaireResponse(payload.questionnaire_response);
    // console.log("Payload to backend:", payload);
  };

  const handleDataChange = (data) => {
    console.log("Prescription Data:", data);
    setPrescriptionData(data);
  };

  const handleResetAll = () => {
    setFormData({
      item_name: "",
      group_name: "",
      categoryname: "",
      brand_name: "",
    });
    setItem_id(null);
    setMuscleCode(null);
    setPrescriptionData(null);
    prescriptionRef.current?.handleReset();
    CrosscheckPageRef.current?.handleResets();
    setDiagnosisData([]);
    setdiagnosisId(null)
    setIsEdit(false)
  };

  const handleSubmit = async () => {
    dispatch(triggerLoader());

    if (!selectedUserId) {
      toast.error("Please select a customer.");
      dispatch(triggerLoader());
      return;
    }

    if (!formData.item_name) {
      toast.error("Please select a Pain Area.");
      dispatch(triggerLoader());
      return;
    }

    if (!questionnaireResponse.length) {
      toast.error("Please fill at least one questionnaire response.");
      dispatch(triggerLoader());
      return;
    }

    try {
      let res;

      if (isEdit) {
        res = await configServ.updateDiagnosis({
          ...formData,
          created_by: user_id,
          customer_id: selectedUserId,
          questionnaire_response: questionnaireResponse,
          diagnosis_id: diagnsisId,
        });
      } else {
        res = await configServ.storeDiagnosis({
          ...formData,
          created_by: user_id,
          customer_id: selectedUserId,
          questionnaire_response: questionnaireResponse,
          // diagnosis_id: diagnosisData.diagnosis_id,
        });
      }

      if (res.success === true) {
        handleResetAll();
        fetchgetActiveDiagnosesForTable();
        setIsCreate(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: isEdit
            ? "Diagnosis updated successfully."
            : "Diagnosis created successfully.",
        });
      } else {
        toast.error(
          isEdit ? "Diagnosis update failed." : "Diagnosis creation failed."
        );
      }
    } catch (e) {
      console.log("Error in diagnosis submit:", e);
      toast.error("Something went wrong.");
    } finally {
      dispatch(triggerLoader());
    }
  };

  const handleUserSelect = (userId) => {
    setSelectedUserId(userId);
    // console.log("Selected User ID:", userId);
  };

  const fetchgetActiveDiagnosesForTable = async () => {
    setLoading(true);
    try {
      const res = await configServ.getActiveDiagnosesForTable();
      if (res.success === true) {
        setDiagnoses(res.data);
      }
    } catch (error) {
      console.error("Error fetching diagnoses:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchgetActiveDiagnosesForTable();
  }, []);

  const handleEditDiagnosis = (diagnosisData) => {
    setDiagnosisData(diagnosisData);
    setdiagnosisId(diagnosisData.diagnosis_id)
    console.log("Editing diagnosis:", diagnosisData);
    // You can now open an edit dialog or navigate to an edit page with this data
  };

  const handleDeleteDiagnosis = async (deleteData) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        // dispatch(triggerLoader());

        const res = await configServ.deleteDiagnosis({
          diagnosis_id: deleteData.diagnosis_id,
        });

        if (res.success === true) {
          toast.success("Diagnosis deleted successfully!");
          fetchgetActiveDiagnosesForTable(); // Refresh table
        } else {
          toast.error("Failed to delete diagnosis.");
        }
      }
    } catch (error) {
      console.log("Error deleting diagnosis:", error);
      toast.error("Something went wrong.");
    } 

    // finally {
    //   dispatch(triggerLoader());
    // }
  };

  return (
    <>
      <CardHeadMenu
        // prefix={"Inv"}
        // suffix={"Order"}
        title={"Create Diagnosis"}
        handlePopup={handlePopup}
        // isEdit={isEdit}
        // handleOTI={handleOTI}
        create={isCreate}
      />

      {isCreate === true && (
        <>
          <motion.div
            style={{
              width: "100%",
              backgroundColor: "#e3f3fc",
              padding: 20,
              paddingLeft: 0,
              borderRadius: "10px",
              border: "none",
              margin: "10px",
            }}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.1, delay: 0.1 }}
          >
            <Box
              sx={{ p: 2 }}
              style={{
                width: "100%",
              }}
            >
              <Typography variant="h5" gutterBottom>
                Create Diagnosis
              </Typography>

              <CustomerDetails
                onUserSelect={handleUserSelect}
                ref={prescriptionRef}
                diagnosisData={diagnosisData}
              />

              <PainAreaForm
                formData={formData}
                setFormData={setFormData}
                setItem_id={setItem_id}
                setMuscleCode={setMuscleCode}
                diagnosisData={diagnosisData}
              />
              <CrosscheckPage
                onResponseChange={handleResponses}
                muscle_code={muscle_code}
                customer_id={selectedUserId}
                ref={CrosscheckPageRef}
                diagnosisData={diagnosisData}
                setDiagnosisData={setDiagnosisData}
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  mt: 2,
                  gap: 2,
                }}
              >
                <Button variant="outlined" onClick={handleResetAll}>
                  Reset
                </Button>
                <Button variant="contained" onClick={handleSubmit}>
                  {isEdit ? <>update </> : <>Save</>}
                </Button>
              </Box>
            </Box>
          </motion.div>
        </>
      )}

      <DiagnosisTable
        diagnoses={diagnoses}
        onEdit={handleEditDiagnosis}
        setIsCreate={setIsCreate}
        loading={loading}
        setIsEdit={setIsEdit}
        onDelete={handleDeleteDiagnosis}
      />
    </>
  );
}
